import styled from 'styled-components';

export const Tag = styled.label`
  display: flex;
  align-items: center;
  background: #11465d;
  height: fit-content;
  justify-content: center;
  margin: auto 0 auto 10px;
  color: white;
  padding: 0.6rem 1rem;
  font-weight: bold;
  border-radius: 20px;
  box-shadow: 0px 0px 5px 2px rgb(3 3 3 / 20%);
  white-space: nowrap;
`;
